// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-contact__link[data-v-32b581a9]{color:#a363ff;cursor:pointer;font-size:inherit;line-height:inherit}", ""]);
// Exports
module.exports = exports;
